import React from 'react';
import styles from './GlobalFooter.module.css';

/**
 * Global footer component that appears on all pages
 * Automatically updates the year for the copyright message
 * @returns {JSX.Element} - Footer with copyright information
 */
const GlobalFooter = () => {
  // Get current year dynamically
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className={styles.footer}>
      <div className={styles.footerText}>© {currentYear} GSD Support Admin Tool<br/></div>

    </footer>
  );
};

export default GlobalFooter;